module.exports = __webpack_public_path__ + "img/item1.ceaaea0e.png";